import {
  Button,
  FormControl,
  Grid,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import withAdminLayout from "components/HoC/withAdminLayout";
import { useFormik } from "formik";
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import * as yup from "yup";
import clsx from 'clsx';
import { DatePicker } from "@material-ui/pickers";
import { get } from "lodash";
import DatetimeService from "services/DatetimeService";
import { isError } from "libs/utils/form";
import { StyledTableCell } from "components/request-document/components/Commons";
import { StyledTableRow } from "components/common/Table";
import InputLabel from '@material-ui/core/InputLabel';
import { useHistory } from "react-router-dom";
import EmployeeService from "services/EmployeeService";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import ReportService from "services/ReportService";
import mime from 'mime';
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  wrapHeader: {
    padding: "3px 10px", borderRadius: "5px", height: "45px", alignItems: "center", display: "flex", color: "gray"
  },
  border1: {
    border: '1px solid rgba(0,0,0,.125)'
  },
  wrapHeaderRight: {
    display: "flex",
    width: '100%',
    justifyContent: 'space-between'
  },
  formControl: {
    padding: "5px",
    width: '100%',
    marginTop: 5
  },
  wrapFilter: {
    height: '100%',
    padding: 0,
    paddingTop: 15
  },
  tableHead: {
    color: "black", backgroundColor: "white", fontWeight: "500", width: "1%", whiteSpace: "nowrap"
  },
  tableCell: {
    backgroundColor: 'white',
    borderBottom: "1px solid rgba(224, 224, 224, 0.5)",
    width: "1%", whiteSpace: "nowrap"
  },
  p0: {
    padding: 0
  }
}));

function createData(date, docNo, firstName, lastName, email, tel, visaType, status, staff) {

  return { date, docNo, firstName, lastName, email, tel, visaType, status, staff };
}
function ReportKPIPage() {
  const classes = useStyles();
  const history = useHistory();
  const [employeeList, setEmployeeList] = useState([]);
  const profile = useSelector((state) => state.user.profile);
  const [Data, setData] = useState([]);
  const dispatch = useDispatch();
  const masterData = useSelector(selectMasterData);
  const department = get(masterData, "department", []);

  const reports = [
    // {
    //   name: 'reportTypeIndustry',
    //   text: 'รายงานคำขอ (ประเภทอุตสาหกรรม)'
    // },
    {
      name: 'reportTypeVisa',
      text: 'รายงานคำขอ (ประเภทคำขอ)'
    },
    {
      name: 'reportKPI',
      text: 'รายงาน KPI (รายบุคคล)'
    }
  ]

  useEffect(() => {
    async function mergedFetchData() {
      await dispatch(
        getMasterData({
          department: true,
        })
      );

      // await fetchData();
    }
    mergedFetchData();


  }, [dispatch]);

  useEffect(async () => {
    await getEmployeeList();
  }, [profile]);

  const getEmployeeList = async () => {

    const response = await EmployeeService.list({ departmentId: profile.departmentId, allStatus: true });
    if (response.status) {
      setEmployeeList(response.results)
    }
  }



  const fetchData = async () => {
    const body = {
      startDate: formik.values?.startDate ? format(new Date(formik.values?.startDate), "yyyy-MM-dd") : null,
      endDate: formik.values?.endDate ? format(new Date(formik.values?.endDate), "yyyy-MM-dd") : null,
      empId: formik.values.empId,
      departmentId: formik.values.departmentId,
    }

    const res = await ReportService.getReportDataKPI(body);

    if (res.status) {
      setData(res.results);
    }

  }


  const validationSchema = yup.object({
    // ContactEmail: yup.string().email("Invalid email format"),
  });

  const flDate = DatetimeService.getFirstAndLastDayOfYear(new Date());

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      reportType: 'reportKPI',
      startDate: flDate.firstDate,
      endDate: flDate.lastDate,
      empId: '',
      departmentId: ''
    },
    onSubmit: async (values) => {
      await fetchData();
    },
  });

  const resetForm = () => {
    formik.resetForm();
  }

  const downloadReport = async () => {
    const body = {
      startDate: formik.values?.startDate ? format(new Date(formik.values?.startDate), "yyyy-MM-dd") : null,
      endDate: formik.values?.endDate ? format(new Date(formik.values?.endDate), "yyyy-MM-dd") : null,
      empId: formik.values.empId,
      departmentId: formik.values.departmentId,

    }

    const blob = await ReportService.getReportExcelKPI(body);

    const blobFile = new File([blob], 'Report KPI.xlsx', {
      type: mime.getType('.xlsx'),
    });

    window.open(
      URL.createObjectURL(blobFile, 'Report KPI.xlsx'),
      "_blank"
    );

  }


  return (
    <Paper className={classes.paper}>
      <form onSubmit={formik.handleSubmit} id="report-kpi" name="report-kpi">
        <div className={classes.wrapForm}>
          <Grid container spacing={0}>
            <Grid item xs={12} lg={2}>
              <div className={clsx(classes.wrapHeader, classes.border1)}>
                Filter
              </div>
            </Grid >

            <Grid item xs={12} lg={10}>
              <div className={clsx(classes.wrapHeader, classes.border1, classes.wrapHeaderRight)}>
                <div >
                  รายงาน KPI
                </div>
                <Button variant="outlined" size="medium" color="primary" className={classes.buttonSave}
                  onClick={() => downloadReport()}>
                  Download
                </Button>
              </div>

            </Grid >
          </Grid >
          <Grid container spacing={0}>
            <Grid item xs={12} lg={2}>
              <div className={clsx(classes.border1, classes.wrapFilter)}>
                <div>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <Select
                      // className={classes.formControl}
                      value={
                        get(formik.values, `reportType`, null) ||
                        null
                      }
                      name="reportType"
                      onChange={(event) => {
                        const reportType = event.target.value;

                        if (reportType === 'reportTypeIndustry') {
                          history.push(`/admin/report/industry`);
                        }

                        if (reportType === 'reportTypeVisa') {
                          history.push(`/admin/report/visaType`);
                        }

                        if (reportType === 'reportKPI') {
                          history.push(`/admin/report/kpi`);
                        }


                        formik.setFieldValue("reportType", event.target.value);
                      }}
                    >
                      {reports.map((config) => (
                        <MenuItem
                          key={config.name}
                          value={config.name}
                        >
                          {config.text}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div>
                  <FormControl variant="outlined" className={clsx(classes.formControl, classes.p0)}>
                    <DatePicker
                      className={classes.formControl}
                      inputVariant="outlined"
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="Start Date"
                      views={["year", "month", "date"]}
                      name={`startDate`}
                      value={
                        get(formik.values, `startDate`, null) ||
                        null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `startDate`,
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError("startDate", formik)}
                    />
                  </FormControl>
                </div>
                <div>
                  <FormControl variant="outlined" className={clsx(classes.formControl, classes.p0)}>
                    <DatePicker
                      className={classes.formControl}
                      inputVariant="outlined"
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="End Date"
                      views={["year", "month", "date"]}
                      name={`endDate`}
                      value={
                        get(formik.values, `endDate`, null) ||
                        null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `endDate`,
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError("endDate", formik)}
                    />
                  </FormControl>
                </div>
                <div>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">Employee</InputLabel>
                    <Select
                      // className={classes.formControl}
                      name="empId"
                      label="Employee"
                      value={formik.values.empId}
                      onChange={formik.handleChange}
                    >
                      <MenuItem value={null}>
                        All
                      </MenuItem>
                      {
                        employeeList.map(e => (
                          <MenuItem value={e.empId} key={e.empId}>
                            {e.employeeFistName} {e.employeeLastName}
                          </MenuItem>
                        ))
                      }


                    </Select>
                  </FormControl>
                </div>

                <div>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">Department</InputLabel>
                    <Select
                      // className={classes.formControl}
                      name="departmentId"
                      label="Department"
                      value={formik.values.departmentId}
                      onChange={formik.handleChange}
                    >
                      <MenuItem value={null}>
                        All
                      </MenuItem>
                      {department.map((config) => (
                        <MenuItem
                          key={config.departmentId}
                          value={config.departmentId}
                        >
                          {config.departmentName}
                        </MenuItem>
                      ))}


                    </Select>
                  </FormControl>
                </div>
                <div className={classes.formControl} style={{ textAlign: 'right' }}>
                  <Button variant="contained" size="medium" color="primary" className={classes.buttonSave} type="submit">
                    Search
                  </Button>
                </div>

              </div>

            </Grid >


            <Grid item xs={12} lg={10}>
              <div className={clsx(classes.border1, classes.wrapFilter)} style={{ padding: 15 }}>
                <TableContainer component={Paper} style={{ borderRadius: 0, maxHeight: '75vh' }}>
                  <Table stickyHeader className={classes.table} size="small" aria-label="a dense table">
                    <TableHead>
                      <StyledTableRow>
                        <TableCell className={classes.tableHead}>Smart No</TableCell>
                        <TableCell className={classes.tableHead} >Visa Type</TableCell>
                        <TableCell className={classes.tableHead} >Staff</TableCell>
                        <TableCell className={classes.tableHead} >Department</TableCell>
                        <TableCell className={classes.tableHead} >Hours</TableCell>


                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {Data.map((row, index) => (
                        <StyledTableRow key={index}>

                          <TableCell className={classes.tableCell} >{row.smartNo}</TableCell>
                          <TableCell className={classes.tableCell} >{row.visaType}</TableCell>
                          <TableCell className={classes.tableCell} >{row.staffFirstName} {row.staffLastName}</TableCell>

                          <TableCell className={classes.tableCell} >{row.departmentName}</TableCell>
                          <TableCell className={classes.tableCell} >{row.sumHours}</TableCell>

                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Grid >
          </Grid >
        </div >
      </form >
    </Paper >
  );
}

export default withAdminLayout(ReportKPIPage);

